var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.noSiteId)?_c('no-site'):[(_vm.fetchingSites)?_c('page-loader'):[(_vm.sites.length < 1)?_c('no-site'):(_vm.loading)?_c('page-loader'):(!_vm.generalRegistrationEnabled)?_c('feature-disabled'):(_vm.subscriptionFeatureAllowed)?[_vm._t("default")]:_c('no-subscription')]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }